import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { KiMarkSize } from '../../../models/ki.model';

const PX_PER_REM = 16;

/** Das einheitliche KI-Zeichen (page-ki.jsx:40-44); reines Symbol, vorgelesen wird die Beschriftung daneben. */
@Component({
  selector: 'app-ki-mark',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'aria-hidden': 'true',
    '[class.ki-mark--inverted]': 'inverted()',
    '[style.width.rem]': 'sizeRem()',
    '[style.height.rem]': 'sizeRem()',
    '[style.font-size.rem]': 'sizeRem() / 2',
  },
  template: `
    KI
  `,
  styles: `
    :host {
      display: inline-grid;
      place-items: center;
      flex-shrink: 0;
      border-radius: 0.25rem;
      background: var(--to-brand);
      color: var(--to-on-brand);
      font-family: inherit;
      font-weight: 700;
      letter-spacing: 0.02em;
    }

    :host(.ki-mark--inverted) {
      background: var(--to-card);
      color: var(--to-brand);
    }
  `,
})
export class KiMarkComponent {
  readonly size = input<KiMarkSize>(16);
  readonly inverted = input(false);

  protected readonly sizeRem = computed(() => this.size() / PX_PER_REM);
}
